import { Suspense, useEffect, useContext, useMemo, useCallback, useState } from "react";
import { Paper } from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";
import { CustomFormDialogType } from "../../../../../../types/components/dialogProps.types";
import PlanHeader from "../../../../../shared/enrollment/planCode/PlanHeader";
import { LazyBrandingActions, LazyCustomFormDialog, LazyPlanBranding } from "../../../../../shared";
import { BBIChristmasClubV2, HealthBenefitBanner } from "../../../../../../assets";
import { BrandingProps, BrandingPropsV2 } from "../../../../../../types/components/enrollmentProps.types";
import { AuthContext, GroupOwnerContext } from "../../../../../../contexts";
import { generateChristmasClubWaiveEnrollmentPayload } from "../../../../../../utils/commonFunctions/groupEnrollment/enrollment";
import { api } from "../../../../../../utils/api";
import { AddEnrollmentPayload } from "../../../../../../utils/api/enrollment/enrollment";
import { trackPromise } from "react-promise-tracker";
import { BBI_PLAN_NAMES } from "../../../../../../constants/plan";
import { CheckPreviousCoreEnrollmentQueryTypes } from "../../../../../../utils/api/enrollment/getCheckPreviousCoreEnrollment";
import CorePreviousBenefitDisclaimer from "../../../../../shared/CorePreviousBenefitDisclaimer/CorePreviousBenefitDisclaimer";
import CorePreviousBenefitDisclaimerV2 from "../../../../../shared/CorePreviousBenefitDisclaimer/CorePreviousBenefitDisclaimerV2";
import { Plan } from "../../../../../../types/plan.types";
import { CCEEnrollment as CCEEnrollmentPayload, EnrollmentSchema } from "../../../../../../types/enrollment.types";
import { getCurrentDate } from "../../../../../../utils/commonFunctions/date";

const CceBranding = ({
	status,
	openEnrollment,
	getEnrollmentInitData,
	changePlanProps,
	alwaysOpenEnrollments,
	planName
}: BrandingPropsV2) => {
	// console.log("===alwaysOpenEnrollments===>", alwaysOpenEnrollments, "planName", planName);
	const [hasPreviousCoreEnrollment, setHasPreviousCoreEnrollment] = useState<boolean>(false);
	const [waiveReason, setWaiveReason] = useState("");
	const { handleChangePlanButtonClick, buttonCaption } = changePlanProps;
	const { member } = useContext(AuthContext);

	const { groupOwner } = useContext(GroupOwnerContext);

	const location = useLocation();
	const history = useHistory();
	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
	const [isWaiveEnrollmentTriggered, setIsWaiveEnrollmentTriggered] = useState(false);
	const [CCEEnrollment, setCCEEnrollment] = useState<EnrollmentSchema | null>(null);
	const [premiumAmount, setPremiumAmount] = useState<string | null>("0.0");
	const [deductionStatus, setDeductionStatus] = useState<"CURRENT DEDUCTION" | "PENDING APPROVAL" | "WAIVED" | null>(
		null
	);
	const handleWaiveReasonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;
		setWaiveReason(value);
	};

	const [customFormDialogProps, setCustomFormDialogProps] = useState<CustomFormDialogType>();
	const [alwaysOpenEnrollment, setAlwaysOpenEnrollment] = useState<Plan | null>(null);

	const findPlanAlwaysOpenEnrollment = useCallback(() => {
		if (!alwaysOpenEnrollments?.length) return;
		for (
			let alwaysOpenEnrollmentIdx = 0;
			alwaysOpenEnrollmentIdx < alwaysOpenEnrollments?.length;
			alwaysOpenEnrollmentIdx++
		) {
			const _alwaysOpenEnrollment = alwaysOpenEnrollments[alwaysOpenEnrollmentIdx];
			if (_alwaysOpenEnrollment.plan_name === planName) {
				setAlwaysOpenEnrollment(_alwaysOpenEnrollment);
				break;
			}
		}
	}, [alwaysOpenEnrollments, planName]);

	// const handleWaiveEnrollment = useCallback(async () => {
	// 	if (member === null || openEnrollment === null) {
	// 		return;
	// 	}
	// 	const { standardDetails, commonDetails } = generateChristmasClubWaiveEnrollmentPayload(
	// 		member,
	// 		openEnrollment,
	// 		waiveReason
	// 	);
	// 	const enrollmentPayload: AddEnrollmentPayload = {
	// 		standard_details: standardDetails,
	// 		common_details: { ...commonDetails, agent_id: groupOwner && groupOwner._id ? groupOwner._id : null }
	// 	};
	// 	const response = await trackPromise(api.enrollment.addEnrollment(enrollmentPayload));
	// 	const step = urlSearchParams.get("step");
	// 	if (response) {
	// 		history.push(`?step=${step}&stage=2`);
	// 	}
	// }, [getEnrollmentInitData, member, openEnrollment, waiveReason, urlSearchParams]);

	const handleWaiveEnrollment = useCallback(async () => {
		if (!member && !premiumAmount && !alwaysOpenEnrollment) {
			return;
		}

		const CCEEnrollmentPayload: CCEEnrollmentPayload = {
			location_number: member.location_number,
			location_name: member.location.location_name,
			group_number: member.group_number,
			plan_object_id: alwaysOpenEnrollment ? alwaysOpenEnrollment._id : "",
			group_name: member.group.name,
			plan_code: alwaysOpenEnrollment ? alwaysOpenEnrollment.plan_code : "",
			plan_name: alwaysOpenEnrollment ? alwaysOpenEnrollment.plan_name : "",
			insured_object_id: member._id,
			insured_SSN: member.SSN,
			enrollment_status: "WAIVED",
			waive_reason: waiveReason,
			enrollment_date: getCurrentDate(),
			premium_amount: Number(premiumAmount)
		};
		// console.log("==CCEEnrollmentPayload==>", CCEEnrollmentPayload);
		const _CCEEnrollment = await api.enrollment.addNonOEEnrollment(CCEEnrollmentPayload);
		setCCEEnrollment(Object.assign({}, _CCEEnrollment));
		// 	if (_CCEEnrollment) {
		// 		alert("Your enrollment has successfully waived");
		// 	}
		// }, [member, premiumAmount]);
		if (_CCEEnrollment) {
			getEnrollmentInitData(false);
		}
		const step = urlSearchParams.get("step");
		history.push(`?step=${step}&stage=2`);
	}, [getEnrollmentInitData, history, member, urlSearchParams, waiveReason, alwaysOpenEnrollment]);

	const handleWaiveButtonClick = useCallback(() => {
		// if (status.openEnrollment === "CLOSED") {
		// 	alert("Enrollment has not been opened for this plan");
		// 	return;
		// }
		setCustomFormDialogProps(
			Object.assign({}, customFormDialogProps, {
				openDialog: true,
				title: "Are you sure want to waive this enrollment?",
				textfields: [
					{
						label: "Waive Reason",
						onChange: handleWaiveReasonChange,
						value: waiveReason,
						placeholder: "Enter your reason for waive"
					}
				],
				actions: [
					{
						label: "Cancel",
						callback: () =>
							setCustomFormDialogProps(Object.assign({}, customFormDialogProps, { openDialog: false }))
					},
					{
						label: "Yes",
						callback: () => {
							setCustomFormDialogProps(
								Object.assign({}, customFormDialogProps, {
									openDialog: false
								})
							);
							// handleWaiveEnrollment();
							setIsWaiveEnrollmentTriggered(true);
						}
					}
				]
			})
		);
	}, [customFormDialogProps, handleWaiveEnrollment, status.openEnrollment, waiveReason]);

	const handleEnrollButtonClick = useCallback(() => {
		// if (status.openEnrollment === "CLOSED") {
		// 	alert("Enrollment has not been opened for this plan. Please contact your administrator");
		// } else {
		const step = urlSearchParams.get("step");
		history.push(`?step=${step}&stage=1`);
		// }
	}, [history, urlSearchParams, status]);

	const getCheckPreviousCoreEnrollment2023 = useCallback(async (group_number, SSN) => {
		const checkPreviousPayload: CheckPreviousCoreEnrollmentQueryTypes = {
			group_number,
			insured_SSN: SSN
		};

		const response = await trackPromise(api.enrollment.getCheckPreviousCoreEnrollment(checkPreviousPayload));

		if (response) {
			for (let idx = 0; idx < response.length; idx++) {
				const eachPlan = response[idx];

				if (eachPlan.plan_name === BBI_PLAN_NAMES.christmas_club_election_form) {
					setHasPreviousCoreEnrollment(true);
				}
			}
		}
	}, []);

	const getPremiumAmount = useCallback(() => {
		if (CCEEnrollment) {
			const { premium_amount, enrollment_status } = CCEEnrollment;
			if (enrollment_status === "ACTIVE") {
				setPremiumAmount(premium_amount + "");
				setDeductionStatus("CURRENT DEDUCTION");
			} else if (enrollment_status === "SUBMITTED") {
				setPremiumAmount(premium_amount + "");
				setDeductionStatus("PENDING APPROVAL");
			} else if (enrollment_status === "WAIVED") {
				setPremiumAmount("0.00");
				setDeductionStatus("WAIVED");
			} else {
				setPremiumAmount("0.00");
				setDeductionStatus(null);
			}
			// if (enrollment_status === "WAIVED") {
			// 	setShowWaiveEnrollmentButton(false);
			// } else {
			// 	setShowWaiveEnrollmentButton(true);
			// }
		}
	}, [CCEEnrollment]);
	useEffect(() => {
		getPremiumAmount();
	}, [CCEEnrollment, getPremiumAmount]);

	useEffect(() => {
		if (member) getCheckPreviousCoreEnrollment2023(member.group_number, member.SSN);
	}, [getCheckPreviousCoreEnrollment2023, member]);

	useEffect(() => {
		if (isWaiveEnrollmentTriggered) {
			handleWaiveEnrollment();
			setIsWaiveEnrollmentTriggered(false); // Reset the trigger
		}
	}, [isWaiveEnrollmentTriggered, handleWaiveEnrollment]);
	useEffect(() => {
		findPlanAlwaysOpenEnrollment();
	}, [findPlanAlwaysOpenEnrollment]);

	return (
		<div className="paper-form-container">
			<Suspense fallback={<div />}>
				{customFormDialogProps ? <LazyCustomFormDialog customFormDialogProps={customFormDialogProps} /> : null}
			</Suspense>
			<Paper className="theme-border-radius paper-container" elevation={1}>
				{alwaysOpenEnrollment ? (
					<PlanHeader planName={alwaysOpenEnrollment?.plan_name} planCode={alwaysOpenEnrollment?.plan_code} />
				) : null}

				<div className="theme-plan-section-margin" />
				<Suspense fallback={<div />}>
					{/* <LazyPlanBranding imgSrc={HealthBenefitBanner} /> */}
					<LazyPlanBranding imgSrc={BBIChristmasClubV2} />
				</Suspense>
				{/* {hasPreviousCoreEnrollment ? <CorePreviousBenefitDisclaimer /> : null} */}
				{hasPreviousCoreEnrollment ? <CorePreviousBenefitDisclaimerV2 /> : null}
				<Suspense fallback={<div />}>
					<LazyBrandingActions
						waiveButtonCallback={handleWaiveButtonClick}
						enrollButtonCallback={handleEnrollButtonClick}
						handleChangePlanButtonClick={handleChangePlanButtonClick}
						buttonCaption={buttonCaption}
						planNameIndicator={BBI_PLAN_NAMES.christmas_club_election_form}
					/>
				</Suspense>
			</Paper>
		</div>
	);
};

export default CceBranding;
